import React from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-charcoal text-gold py-3 px-4 shadow-md" data-id="element-188">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 text-center text-sm md:text-base font-medium" data-id="element-189">
        <Clock className="w-4 h-4 animate-pulse" data-id="element-190" />
        <span data-id="element-191">
          <strong className="font-bold tracking-wider" data-id="element-192">ATENCIÓN:</strong> El
          precio de lanzamiento de $11.99 finaliza hoy a las 11:59 PM. Quedan
          menos de 47 licencias con los 5 bonos incluidos.
        </span>
      </div>
    </div>;
}